// client/src/lib/protected-route.tsx
import { useLocation } from 'wouter';
import { useEffect, ComponentType } from 'react';
import { useAppContext } from './AppContext';

interface ProtectedRouteProps {
  path: string;
  component: ComponentType<{ className?: string }>;
  user: any;
  loading: boolean;
  className?: string;
}

export function ProtectedRoute({ path, component: Component, user, loading, className }: ProtectedRouteProps) {
  const [, setLocation] = useLocation();
  const { isAuthenticated } = useAppContext();

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      setLocation('/auth', { replace: true });
    }
  }, [isAuthenticated, loading, setLocation, path]);

  if (loading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  if (!isAuthenticated) {
    return null;
  }

  return <Component className={className} />;
}